module.exports = __webpack_public_path__ + "667c7a422ea1e92f971848ef8bb347ce.svg";